import { useCallback, useEffect, useState } from 'react'
import { useProjectPlanSnapshotRepository } from '../../../../../../../services/adaptors/projectPlanSnapshotRepositoryAdaptor'
import { TeamSelectRow } from '../model'

type UseTeamSelectDataProps = {
  snapshotUuid: string
}

export const useTeamSelectData = ({ snapshotUuid }: UseTeamSelectDataProps) => {
  const { fetchReferencedValues } = useProjectPlanSnapshotRepository()
  const [rows, setRows] = useState<TeamSelectRow[]>([])
  const [isLoading, setIsLoading] = useState(true)

  const fetchSnapshotData = useCallback(
    async (uuid: string) => {
      const response = await fetchReferencedValues(uuid, 'TEAM_ENTITY')
      return response.map(resp => ({
        uuid: resp.value,
        displayName: resp.name,
      }))
    },
    [fetchReferencedValues]
  )

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true)
        const result = await fetchSnapshotData(snapshotUuid)
        setRows(result)
      } catch (error) {
        console.error('Failed to fetch team data:', error)
        setRows([])
      } finally {
        setIsLoading(false)
      }
    }

    fetchData()
  }, [snapshotUuid, fetchSnapshotData])

  return {
    rows,
    isLoading,
  }
}
